<template>
  <div class="spoiledText" :class="{spoiledText__bottomBorder: isBottom}">
      <div class="spoiledText__header" @click.prevent.stop="spoiled=!spoiled"> <span>{{ header }}</span>
        <i>
          <svg class="spoiledText__icon" :class="{'spoiledText__rotate': !spoiled }"
               @click.prevent.stop="spoiled=!spoiled"
               width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </i>
      </div>

      <transition name="spoiledText" type="transition">
        <div class="spoiledText__text" v-if="!spoiled">{{text}}</div>
      </transition>
  </div>
</template>

<script>
import {ref} from "vue";

export default {
  name: "SpoiledText",
  props: ['text', 'header', 'isBottom'],
  setup() {
    const spoiled = ref(true)
    return {spoiled}
  }
}
</script>

<style scoped lang="scss">
.spoiledText {
  color: var(--cd-spoiler-text-color, #FFFFFFC4);
  user-select: none;
  border-top: 1px solid var( --cd-spoiler-border-color, #FFFFFF1C);
  font-size: 16px;
  font-family: var(--cd-default-font);
  &__bottomBorder {
    border-bottom: 1px solid var( --cd-spoiler-border-color, #FFFFFF1C);
  }
  &__header {
    padding: 10px;
    position: relative;
    cursor: pointer;
  }
  &__icon {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 16px;
    width: 13px;
    height: 7px;
  }
  &__rotate {
    transform: rotate(180deg);
  }
  &__text {
    padding: 10px;
  }
}
</style>
